import React from 'react'
import { InfoTooltip } from '../../InfoTooltip'
import type { MetricCardProps } from './MetricCard.types'
import {
  Container,
  Header,
  Title,
  TooltipContainer,
  ValueContainer,
  Value,
  Subtitle,
  TrendContainer,
  TrendIcon,
  IconContainer,
} from './MetricCard.styles'

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  variant = 'default',
  tooltip,
  icon,
  trend,
  className,
  style,
  onClick,
  disabled = false,
}) => {
  return (
    <Container
      $variant={variant}
      $disabled={disabled}
      $clickable={!!onClick}
      onClick={onClick}
      className={className}
      style={style}
    >
      {icon && <IconContainer>{icon}</IconContainer>}

      <Header>
        <Title>{title}</Title>
        {tooltip && (
          <TooltipContainer>
            <InfoTooltip>{tooltip}</InfoTooltip>
          </TooltipContainer>
        )}
      </Header>

      <ValueContainer>
        <Value $variant={variant}>{value}</Value>
      </ValueContainer>

      {subtitle && <Subtitle>{subtitle}</Subtitle>}

      {trend && (
        <TrendContainer $direction={trend.direction || 'neutral'}>
          <TrendIcon $direction={trend.direction || 'neutral'} />
          {trend.value > 0 && trend.direction !== 'down' && '+'}
          {trend.value}
          {trend.label && ` ${trend.label}`}
        </TrendContainer>
      )}
    </Container>
  )
}

MetricCard.displayName = 'MetricCard'
